import React from 'react';
import { TabGridContianer } from './OrderDetailTab.styled';
import OrderDetailTabList from './OrderDetailTab';
import { isMobileView } from 'src/utils/util';

const OrderDetailTabListContainer = ({
    orderDetailTabList,
    tabActiveId,
    tabSwitch,
    isCondensedView
}) => {
    return (
        <>
            <TabGridContianer isCondensedViewMobile={isCondensedView && isMobileView()}>
                {orderDetailTabList.map((orderTab) => {
                    return (
                        <OrderDetailTabList
                            key={orderTab.id}
                            label={orderTab.label}
                            id={orderTab.id}
                            isTabActive={tabActiveId === orderTab.id}
                            tabSwitch={tabSwitch}
                        />
                    );
                })}
            </TabGridContianer>
        </>
    );
};

export default OrderDetailTabListContainer;
